<template>
    <div>
        <v-card elevation="0">
            <v-card-title>
                {{ aluno.ra }} - {{aluno.nome}}
            </v-card-title>
            <v-card-subtitle>
                <v-chip class="mr-2" title="Turma" label color="purple">{{aluno.codturma}}</v-chip>
                <v-chip class="mr-2" title="Série" label color="info">{{aluno.habilitacao}}</v-chip>
                <v-chip class="mr-2" title="Período Letivo" label color="warning">{{aluno.codperlet}}</v-chip>
                <br>
                Você está registrando um nova entrega de material relacionada ao período letivo {{aluno.codperlet}}
            </v-card-subtitle>
        </v-card>
        <v-divider class="my-2"></v-divider>
    </div>
</template>
<script>

export default {
    props: {
        aluno: {
            required: true
        }
    },
}
</script>